import { formControlFactory } from "../../lib/formControlFactory";
import * as Components from "./components";
export const TextArea = formControlFactory({
    emptyValue: "",
    component: Components.InternalTextAreaView,
    propMapping: (props) => {
        const rules = {
            ...(props.rules ?? {}),
        };
        // don't allow only whitespaces per default
        // when simple required is used
        if (rules.required === true) {
            rules.validate = {
                ...rules.validate,
                required: (v) => v.trim().length !== 0,
            };
        }
        return { ...props, rules };
    },
});
TextArea.displayName = "TextArea";
export default TextArea;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEFyZWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0QXJlYS9UZXh0QXJlYS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFDbEUsT0FBTyxLQUFLLFVBQVUsTUFBTSxjQUFjLENBQUM7QUFFM0MsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFHLGtCQUFrQixDQUFDO0lBQ3pDLFVBQVUsRUFBRSxFQUFFO0lBQ2QsU0FBUyxFQUFFLFVBQVUsQ0FBQyxvQkFBb0I7SUFDMUMsV0FBVyxFQUFFLENBQUMsS0FBSyxFQUFFLEVBQUU7UUFDckIsTUFBTSxLQUFLLEdBQUc7WUFDWixHQUFHLENBQUMsS0FBSyxDQUFDLEtBQUssSUFBSSxFQUFFLENBQUM7U0FDdkIsQ0FBQztRQUVGLDJDQUEyQztRQUMzQywrQkFBK0I7UUFDL0IsSUFBSSxLQUFLLENBQUMsUUFBUSxLQUFLLElBQUksRUFBRSxDQUFDO1lBQzVCLEtBQUssQ0FBQyxRQUFRLEdBQUc7Z0JBQ2YsR0FBRyxLQUFLLENBQUMsUUFBUTtnQkFDakIsUUFBUSxFQUFFLENBQUMsQ0FBTSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxFQUFFLENBQUMsTUFBTSxLQUFLLENBQUM7YUFDNUMsQ0FBQztRQUNKLENBQUM7UUFFRCxPQUFPLEVBQUUsR0FBRyxLQUFLLEVBQUUsS0FBSyxFQUFFLENBQUM7SUFDN0IsQ0FBQztDQUNGLENBQUMsQ0FBQztBQUVILFFBQVEsQ0FBQyxXQUFXLEdBQUcsVUFBVSxDQUFDO0FBRWxDLGVBQWUsUUFBUSxDQUFDIn0=